import { Box, Typography, IconButton } from "@mui/material";
import LinkRouter from "components/navigation/LinkRouter";
import { ArrowRight, Check, Circle } from "lucide-react";
import { OnboardingTask } from "./OnboardingTypes";

export const Task = ({ task }: { task: OnboardingTask }) => {
  return (
    <Box
      key={task.label}
      sx={{
        display: "flex",
        alignItems: "start",
        gap: "8px",
      }}
    >
      {task.completed ? (
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            background: "#198282",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Check size={16} color="white" strokeWidth={2.5} />
        </Box>
      ) : (
        <Circle
          size={24}
          stroke="#bdbdbd"
          fill="none"
          style={{ flexShrink: 0 }}
        />
      )}

      <Typography variant="body" sx={{ display: "inline", lineHeight: "24px" }}>
        {task.label}
        {!task.completed && task.url && (
          <LinkRouter
            to={task.url}
            targetNew={task.openNewTab}
            style={{ display: "inline", textDecoration: "none" }}
          >
            <IconButton
              sx={{
                padding: 0,
                verticalAlign: "middle",
                marginLeft: "4px",
              }}
            >
              <ArrowRight size={24} color="#198282" />
            </IconButton>
          </LinkRouter>
        )}
      </Typography>
    </Box>
  );
};
